import buildJokeCard from "../objectsForCard/build_joke_card";

export const replaceInvalidCardEvents = (currentCardList, checkTable, checkType, gamePhase) => {
    //  this proccess goes thru the card hand and replaces any events that are
    //  no longer valid due to changes in the conditions table or
    //  skipCategory conditions
     //  check all cards in the cardlist to ensure that the condition is still valid, 
    //  if not substitute card with a joke card.
    let newCardList = [];
    let replaceCard = false;
    for (let i=0; i<currentCardList.length; i++){
        let card = currentCardList[i];
        if (checkType === "conditionArr"){
            if (!card.conditionArr  || card.conditionArr.length === 0){
                // no conditions so card s/b selected
            }else{
                for (let j=0; j<card.conditionArr.length; j++){
                    let condition = card.conditionArr[j];
                    const conditionCheck = checkTable.find(elem => elem.condName === condition);
                    if (!conditionCheck){
                        //  condition for card is no longer valid for this game
                        replaceCard = true;
                        break;
                    }
                }
            }   
            if (card.careerTag && card.careerTag !== ""){
                const careerName = card.careerTag;
                const conditionCheck = checkTable.find(elem => elem.condName === careerName);
                if (!conditionCheck){
                    //  career has been changed and card is no longer valid
                    replaceCard = true;
                }
            }
        }
        if (checkType === "skipEventArr"){
            if (checkTable.includes(card.eventCategory)){
                replaceCard = true;
            }else{
                replaceCard = false;
            }
        }
                    
        if (replaceCard === false){
            newCardList.push(card);
        }else{
            let jokeCard = buildJokeCard(gamePhase);
            newCardList.push(jokeCard);
        }
    }
    return newCardList;
}
export default replaceInvalidCardEvents;